import React from "react";
import Appraisal from "../../appraisal/Appraisal";

export default function AppraisalPage() {
  return <Appraisal />;
}
